<nav class="langtabs__nav" *ngIf="hasMultilang">
    <span *ngFor="let lang of langs; let i = index">
        <a [ngClass]="{'langtabs__link--active': i === activeLangIndex}" class="langtabs__link langtabs__link--inverted"
            (click)="switchTab(i)">
            {{ lang }}
        </a>
    </span>
</nav>
<ng-container *ngIf="hasMultilang">
    <div *ngFor="let lang of langs; let i = index">
        <div [ngClass]="{'langtabs__content--active': i === activeLangIndex}" class="langtabs__content langtabs__content--inverted"
            id="seo-langtab-{{ lang }}">
            <div *ngFor="let field of fields[lang]">
                <swb-form-field [field]="field" [form]="form" [lang]="lang"></swb-form-field>
            </div>
        </div>
        <div style="clear:both"></div>
    </div>
</ng-container>
<div class="form__container">
    <div *ngFor="let field of fields['unilang']">
        <swb-form-field [field]="field" [form]="form"></swb-form-field>
    </div>
</div>
